
import React from 'react';

const AboutSection: React.FC = () => {
  const features = [
    {
      icon: 'ri-play-circle-line',
      title: 'Acceso Inmediato',
      description: 'Comienza hoy mismo. Plataforma disponible 24/7'
    },
    {
      icon: 'ri-time-line',
      title: 'A Tu Ritmo',
      description: 'Estudia cuando quieras, sin horarios fijos. Contenido siempre disponible'
    },
    {
      icon: 'ri-medal-line',
      title: 'Certificación Oficial',
      description: 'Diploma acreditativo al finalizar los 23 módulos del programa'
    }
  ];

  return (
    <section className="py-20 bg-teal-50/50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Formación 100% Online en Plataforma Moodle
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Accede a una plataforma de aprendizaje profesional diseñada específicamente para la formación veterinaria
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center group">
              <div className="w-20 h-20 mx-auto mb-6 bg-white rounded-full flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110">
                <i className={`${feature.icon} text-3xl text-teal-500`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* Imagen adicional */}
        <div className="mt-16 relative">
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://public.readdy.ai/ai/img_res/5f56e0efa7efd35c8f17b20a9cee4dbe.jpg"
              alt="Plataforma Moodle para veterinarios"
              className="w-full h-64 object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-teal-500/20 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
